import { AddUnitForm } from './AddUnit.types';

export const addUnitFormDefaultValues: AddUnitForm = {
  isCommercial: false,
  isKdr: false,
  kdrFrom: '',
  kdrTo: '',
  member: '',
  memberFrom: '',
  memberTo: '',
  members: [],
  share: 1,
  unitNumber: '',
};
